import { Line } from '../cartesian/index';

const isEmpty = (v) => v === undefined || v === null;

const BreakDot = (props) => {
  const { dataKey, index, chartData } = props;
  const prev = chartData[index - 1];
  const next = chartData[index + 1];
  const prevValue = prev && prev[dataKey];
  const nextValue = next && next[dataKey];

  return isEmpty(prevValue) || isEmpty(nextValue)
    ? Line.renderDotItem(true, props)
    : null;
};

export default BreakDot;
